import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combina classes Tailwind aproveitando deduplicação. Usado por todos os componentes.
 *
 * @param inputs - classes a serem combinadas
 * @returns string única com classes válidas
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
